(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

class PromiseBox {
  constructor() {
    let names = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    names.forEach(name => {
      this[name] = null;
    });
  }

  cancelPromise(pName) {
    const p = this[pName];

    if (p && p.cancel) {
      p.cancel();
    }

    this[pName] = null;
  }

  cancelPromises() {
    const usedKeys = ["cancelPromise", "cancelPromises"];
    Object.getOwnPropertyNames(this).filter(k => !usedKeys.includes(k)).forEach(this.cancelRequest);
  }

  // @ts-ignore
  __reactstandin__regenerateByEval(key, code) {
    // @ts-ignore
    this[key] = eval(code);
  }

}

const _default = PromiseBox;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(PromiseBox, "PromiseBox", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/utils/promiseBox.js");
  reactHotLoader.register(_default, "default", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/utils/promiseBox.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();